export default "__VITE_ASSET__Dn724J6O__"